var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_Like",
    width: 39.864,
    height: 36.609,
    "data-name": "Icon / Like",
    viewBox: "0 0 39.864 36.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path",
    fill: "none",
    stroke: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.048.011a11.117 11.117 0 0 0-7.5 3.435l-.614.637-.614-.637a11.013 11.013 0 0 0-16 0 12.1 12.1 0 0 0 0 16.637l15.386 16a1.694 1.694 0 0 0 2.461 0l15.386-16a12.094 12.094 0 0 0 0-16.637 11.1 11.1 0 0 0-8-3.446z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.569 2l-.451.01c-2.311.112-4.488 1.114-6.133 2.825l-.614.637-1.44 1.493-1.44-1.493-.615-.639c-1.757-1.826-4.087-2.832-6.56-2.832-2.474 0-4.804 1.006-6.56 2.832-3.677 3.822-3.677 10.042 0 13.864L19.93 34.474l15.176-15.777c.876-.91 1.562-1.977 2.037-3.17.477-1.198.72-2.464.72-3.762s-.243-2.564-.72-3.762c-.476-1.193-1.16-2.26-2.038-3.17C33.356 3.01 31.034 2.005 28.57 2m-.022-2c3.001 0 5.88 1.24 8.001 3.446 2.123 2.206 3.316 5.199 3.316 8.319 0 3.12-1.193 6.113-3.316 8.318L21.162 36.08c-.34.354-.785.53-1.23.53-.446 0-.892-.176-1.231-.53L3.314 20.083c-4.419-4.594-4.419-12.042 0-16.636C5.524 1.15 8.42 0 11.316 0c2.896 0 5.792 1.149 8.001 3.446l.614.637.614-.637C22.55 1.363 25.228.14 28.048.01L28.547 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.330f9caace414cb8d1305c872df16086.svg";
export { ForwardRef as ReactComponent };